import { GET_ALL_STORES } from './ApiConstants';
import api from './ApiHandler';

export const getStoresByPage = async (payload: any) => {
  return await api.get(GET_ALL_STORES, { params: payload });
};
